import { Component, OnInit } from '@angular/core';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-tracking-email-config-dropdown',
  templateUrl: '../template-dropdown.html'
})
export class TrackingEmailConfigDropdownComponent extends DropdownBaseComponent implements OnInit {

  constructor(
    private readonly dropdownService: DropDownService,
    protected readonly translatorService: TranslatorService
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);
    this.itemsData = [
      { id: true, name: this.translatorService.trans('tracking.email.true') },
      { id: false, name: this.translatorService.trans('tracking.email.false') },
    ];
  }

}
